import { makeStyles } from '@policygenius/mortar';

export default makeStyles((theme) => ({
  content: {
    marginBottom: theme.spacing('xlarge'),
  },
}));
